
import { computed, defineComponent } from 'vue'
const DEFAULT_EMPLOYEE_NAME = 'server'

export default defineComponent({
	name: 'AddedBy',

	props: {
		addedBy: {
			type: String,
			default: ''
		},

		isPickup: {
			type: Boolean,
			default: false
		}
	},

	setup(props) {
		// Computed
		const getAddedByAdditionalClass = computed(() => {
			if (props.addedBy && props.addedBy !== DEFAULT_EMPLOYEE_NAME) {
				return 'bright'
			}

			return ''
		})

		return { getAddedByAdditionalClass }
	}
})
